jQuery(document).ready(function ($) {
  
  jQuery('ul.drawer__nav .text-link').click(function(){
      jQuery('.drawer__nav').find('.meganav--active').removeClass('meganav--active');
      jQuery('.drawer__nav').find('.meganav--drawer').hide();
      jQuery(this).addClass('meganav--active');
      jQuery(this).closest('.drawer__nav-item').find('.meganav--drawer').show();
  }); 

  jQuery('figure.zoom').click(function(e){
     var $this = jQuery(this);
     var image = $this.closest('a').attr('href');
    
     if ($("figure.zoom").hasClass("active") ){
         jQuery(this).removeClass("active");
         jQuery('figure.zoom').attr('style','background-image:url("")');
      } else {
         jQuery('figure.zoom').attr('style','background-image:url("'+image+'")');
         jQuery(this).addClass("active");
      }
  });
  
  jQuery('.product-single__thumbnail-item').click(function(e){
     var $this = jQuery(this);
     var image = $this.find('a').data('zoom');
     jQuery('figure.zoom').closest('a').attr('href',image);
     jQuery('figure.zoom').attr('style','background-image:url("'+image+'")');
  });
    
  jQuery('figure.zoom').mousemove(function(e){
      if ($("figure.zoom").hasClass("active") ){
        zoom(e);
      } 
  });
  
  function zoom(e) {
     var zoomer = e.currentTarget;
     e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
     e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
     x = offsetX/zoomer.offsetWidth*100
     y = offsetY/zoomer.offsetHeight*100
     zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }

function call_cart_item(){
  setTimeout(function(){
		jQuery.getJSON('/cart.js', function(cart){ 
			var result = cart.item_count;
            result = result ? result : 0;
            jQuery('.site-header__upper .site-header__cart').find('.inner-count').html( result );
            if( result == 0){
                jQuery('.current-cart-count').addClass('hide');
           }else {
               jQuery('.current-cart-count').removeClass('hide');
           }
          
		});
	},300);
}

jQuery('#AddToCart-product-template').click(function(){
	call_cart_item();
});
jQuery('button').click(function(){
	call_cart_item();
});
$(document).on("click touchend", ".slide-cart-product-delete, .slide-cart-quantity__button, .cart-slider-pointer, #AddToCart-product-template, .ufe-btn", function () {
    call_cart_item();
});

  // SHOP-678 - Start
  jQuery('.cd-faq-trigger').on('click', function(event){
    event.preventDefault();
    var parentItem = jQuery(this).parent().parent();

    if (parentItem.hasClass('open')) {
      parentItem.removeClass('open');
    } else {
      jQuery('.cd-faqitem').removeClass('open');
      jQuery('.cd-faq-trigger').not(this).removeClass('active');
      jQuery('.cd-faq-content').not(jQuery(this).next()).slideUp(200);
      jQuery('li').not(parentItem).removeClass('content-visible');
      parentItem.addClass('open');
    }
  });
  // SHOP-678 - End
  
});  
